import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelDynamic as _vModelDynamic, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "my-2" }
const _hoisted_2 = { class: "create-service-card" }
const _hoisted_3 = { class: "row gy-2" }
const _hoisted_4 = { class: "col-12 col-md-2 col-xl-1 px-1" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "field-label" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-12 col-md px-1" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "field-label" }
const _hoisted_11 = { class: "col-12 col-md px-1" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "field-label" }
const _hoisted_14 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_16 = { class: "is-invalid" }
const _hoisted_17 = { class: "col-12 col-md px-1" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "field-label" }
const _hoisted_20 = { class: "col-12 col-md px-1" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "field-label" }
const _hoisted_23 = { class: "col-12 col-md px-1" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "field-label" }
const _hoisted_26 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_27 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_28 = { class: "is-invalid" }
const _hoisted_29 = { class: "col-12 col-md-2 col-xl-1 px-1" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "field-label" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "row gy-2 align-items-end" }
const _hoisted_35 = { class: "col-12 col-md-4 col-xl-3 px-1" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "field-label" }
const _hoisted_38 = ["value", "selected"]
const _hoisted_39 = { class: "is-invalid" }
const _hoisted_40 = { class: "col-12 col-md-3 col-xl-2 px-1" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = { class: "form-check form-switch mb-0" }
const _hoisted_43 = {
  class: "form-check-label",
  for: "isTestServiceToggle"
}
const _hoisted_44 = {
  key: 0,
  class: "col-12 col-md-4 col-xl-3 px-1"
}
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = { class: "field-label" }
const _hoisted_47 = { class: "col px-1 d-flex justify-content-end" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_50 = {
  key: 1,
  class: "fa-solid fa-paper-plane me-2"
}
const _hoisted_51 = {
  key: 0,
  class: "row gy-2"
}
const _hoisted_52 = { class: "col-12 px-1" }
const _hoisted_53 = {
  class: "test-notice d-flex align-items-center mb-0",
  role: "alert"
}

import { Field, Form, FormActions, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import Service from '@/models/Service'
import AutoComplete from '@/components/AutoComplete.vue'
import { AutoCompleteType } from '@/types/AutoCompleteType'
import ClientRepository from '@/repositories/ClientRepository'
import { LocationType } from '@/types/LocationType'
import { ServiceInterface } from '@/types/ServiceInterface'
import { computed, onMounted, ref, Ref, watch } from 'vue'
import ServiceRepository from '@/repositories/ServiceRepository'
import ToastService from '@/services/ToastService'
import i18n from '@/plugins/i18n'
import { ClientInterface } from '@/types/ClientInterface'
import { usePlacesStore } from '@/services/stores/PlacesStore'
import { useClientsStore } from '@/services/stores/ClientsStore'
import { storeToRefs } from 'pinia'
import { CountryCodeType } from '@/types/CountryCodeType'
import { StrHelper } from '@/helpers/StrHelper'
import { useWpClientsStore } from "@/services/stores/WpClientStore";
import AuthService from '@/services/AuthService'
import { useSettingsStore } from "@/services/stores/SettingsStore";
import { useDriversStore } from '@/services/stores/DriversStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateService',
  setup(__props) {

const placesAutocomplete: Ref<Array<AutoCompleteType>> = ref([])
const clientsPhone: Ref<Array<AutoCompleteType>> = ref([])
const placesStore = usePlacesStore()
const clientsStore = useClientsStore()
const settingsStore = useSettingsStore()
let start_loc: LocationType | null = null
let end_loc: LocationType | null = null
const service: Ref<Partial<Service>> = ref(new Service())
const submitting = ref(false)
const {
  countryCodes,
  isReady: clientsReady,
} = storeToRefs(clientsStore)
const {
  isReady: placesReady,
} = storeToRefs(placesStore)
const countryCode: Ref<CountryCodeType> = ref(countryCodes.value[0])
const count: Ref<number> = ref(1)
const { clients: wpClients, defaultClient } = storeToRefs(useWpClientsStore())
const { branchSelected } = storeToRefs(settingsStore)
const { drivers } = useDriversStore()
const isTestService = ref(false)
const targetDriverId: Ref<string | null> = ref(null)
const targetDriverPlates = computed<Array<AutoCompleteType>>(() => {
  return drivers.reduce((plates: Array<AutoCompleteType>, driver) => {
    const plate = driver.selected_vehicle?.plate ?? driver.vehicle?.plate
    if (driver.id && plate) {
      plates.push({ id: driver.id, value: plate })
    }
    return plates
  }, [])
})

watch(() => service.value.name, (name) => {
  service.value.name = StrHelper.toCamelCase(name ?? '')
})

watch(isTestService, (enabled) => {
  if (enabled) {
    count.value = 1
  } else {
    targetDriverId.value = null
  }
})

const schema = yup.object().shape({
  wp_client_id: yup.string().required().min(9),
  name: yup.string().required().min(3),
  phone: yup.string().required().min(9).max(10),
  start_address: yup.string().required(),
  comment: yup.string().nullable(),
})

const fallbackCountryCode = computed(() => countryCodes.value[31] ?? countryCodes.value[0])
const clientsAutocompleteReady = computed(() => clientsReady.value || clientsStore.clients.length > 0)
const placesAutocompleteReady = computed(() => placesReady.value || placesStore.places.length > 0)

onMounted(() => {
  countryCode.value = countryCodes.value.find((code) => code.dialCode === branchSelected.value?.calling_code) ?? fallbackCountryCode.value
  const input = document.querySelector('input[name="phone"]') as HTMLInputElement
  input?.focus()
})

function submitFromEnter(event: Event) {
  const input = document.querySelector('input[name="comment"]') as HTMLInputElement
  if (input !== document.activeElement) event.preventDefault()
}

async function onSubmit(values: ServiceInterface, event: FormActions<any>): Promise<void> {
  if (!start_loc) {
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), i18n.global.t('services.messages.no_start_loc'))
    return
  }

  if (isTestService.value && !targetDriverId.value) {
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), i18n.global.t('services.messages.test_driver_required'))
    return
  }

  const currentClient = values.client_id ? await clientsStore.findById(values.client_id) : null
  if (!values.client_id || currentClient?.name !== values.name) {
    submitting.value = true
    try {
      const client = await createClient({
        id: '',
        name: values.name,
        phone: values.phone,
      })
      values.client_id = client.id
      await clientsStore.updateClient(client)
      clientsPhone.value = [{ id: client.id, value: client.phone }, ...clientsPhone.value]
        .filter((candidate, index, collection) => collection.findIndex((item) => item.id === candidate.id) === index)
        .slice(0, 10)
      ToastService.toast(ToastService.SUCCESS, i18n.global.t('services.messages.new_client'))
    } catch (e: any) {
      ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
      submitting.value = false
      return
    }
  }

  createService(values)
  event.resetForm()
}

function createService(values: ServiceInterface): void {
  submitting.value = true
  if (!start_loc || !branchSelected.value) {
    submitting.value = false
    return
  }
  if (values.created_by === undefined) {
    values.created_by = AuthService.getCurrentUser()?.id ?? null
  }
  const newService: Service = new Service()
  const startLocWithBranch: LocationType = {
    ...start_loc,
    country: branchSelected.value.id,
    city: branchSelected.value.city.id,
  }
  const endLocWithBranch: LocationType | null = end_loc ? {
    ...end_loc,
    country: branchSelected.value.id,
    city: branchSelected.value.city.id,
  } : null
  newService.comment = values.comment ?? null
  newService.client_id = values.client_id
  newService.name = values.name
  newService.phone = values.phone
  newService.start_loc = startLocWithBranch
  newService.end_loc = endLocWithBranch
  newService.wp_client_id = values.wp_client_id
  newService.created_by = values.created_by
  if (isTestService.value) {
    newService.origin = Service.ORIGIN_TEST
    newService.directed_to = targetDriverId.value
  }
  ServiceRepository.create(newService, isTestService.value ? 1 : count.value).then(() => {
    count.value = 1
    countryCode.value = fallbackCountryCode.value
    service.value.wp_client_id = defaultClient.value as string
    start_loc = null
    end_loc = null
    isTestService.value = false
    targetDriverId.value = null
    ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.created'))
  }).catch((e) => {
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  }).finally(() => {
    submitting.value = false
  })
}

function onClientSelected(element: AutoCompleteType): void {
  clientsStore.findById(element.id).then((client) => {
    if (!client) return
    service.value.phone = client.phone
    service.value.name = client.name
    service.value.client_id = client.id
  })
  const input = document.querySelector('input[name="start_address"]') as HTMLInputElement
  input?.focus()
}

function createClient(client: ClientInterface): Promise<ClientInterface> {
  const identifiers = buildClientIdentifiers(client.phone)
  client.phone = identifiers.phone
  client.id = identifiers.id
  return ClientRepository.create(client)
}

async function checkPhoneNoExists(phone: string): Promise<void> {
  if (!clientsAutocompleteReady.value || phone.length <= 3) {
    return
  }

  const matchingClients = await clientsStore.searchClients(phone, 10)
  const normalizedPhone = sanitizeDigits(phone)
  const phoneExists = matchingClients.some((client) => sanitizeDigits(client.phone).includes(normalizedPhone))
  if (!phoneExists) {
    service.value.name = i18n.global.t('common.models.users')
  }
}

async function locSelected(element: AutoCompleteType): Promise<void> {
  const place = await placesStore.findByName(element.value)
  if (!place || !branchSelected.value) return
  start_loc = {
    name: place.name,
    lat: place.lat,
    lng: place.lng,
    country: branchSelected.value.country,
    city: branchSelected.value.city.id,
  }
  const endAddressInput = document.querySelector('input[name="end_address"]') as HTMLInputElement
  if (endAddressInput) {
    endAddressInput.focus()
    return
  }
  const input = document.querySelector('input[name="comment"]') as HTMLInputElement
  input?.focus()
}

function onStartAddressChange(): void {
  start_loc = null
}

async function endLocSelected(element: AutoCompleteType): Promise<void> {
  const place = await placesStore.findByName(element.value)
  if (!place || !branchSelected.value) return
  end_loc = {
    name: place.name,
    lat: place.lat,
    lng: place.lng,
    country: branchSelected.value.country,
    city: branchSelected.value.city.id,
  }
  const input = document.querySelector('input[name="comment"]') as HTMLInputElement
  input?.focus()
}

function onEndAddressChange(): void {
  end_loc = null
}

function onTargetDriverSelected(element: AutoCompleteType): void {
  targetDriverId.value = element.id
}

function onTargetDriverChange(): void {
  targetDriverId.value = null
}

function buildClientIdentifiers(phone: string): { phone: string, id: string } {
  const dialDigits = sanitizeDigits(countryCode.value?.dialCode ?? '')
  const expectedLength = countryCode.value?.dialCode?.includes('+56') ? 9 : 10
  let digitsOnlyPhone = sanitizeDigits(phone)
  let localNumber = digitsOnlyPhone

  if (dialDigits && localNumber.startsWith(dialDigits) && localNumber.length > expectedLength) {
    localNumber = localNumber.substring(dialDigits.length)
  }

  if (localNumber.length > expectedLength) {
    localNumber = localNumber.slice(-expectedLength)
  }

  const normalizedPhone = dialDigits.concat(localNumber) || localNumber

  return {
    phone: normalizedPhone,
    id: normalizedPhone,
  }
}

function sanitizeDigits(value: string): string {
  return value.replace(/[^\d]/g, '')
}

async function searchClientsAutocomplete(term: string): Promise<Array<AutoCompleteType>> {
  const results = await clientsStore.searchClients(term, 10)
  const mapped = results.map((client) => ({
    id: client.id,
    value: client.phone,
  }))
  clientsPhone.value = mapped
  return mapped
}

async function searchPlacesAutocomplete(term: string): Promise<Array<AutoCompleteType>> {
  const placesResult = await placesStore.searchPlaces(term, 10)
  const mapped = placesResult.map((place) => ({
    id: place.key ?? place.id,
    value: place.name,
  }))
  placesAutocomplete.value = mapped
  return mapped
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Form), {
        onSubmit: onSubmit,
        "validation-schema": _unref(schema),
        autocomplete: "off",
        onKeydown: _withKeys(submitFromEnter, ["enter"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('services.labels.code')), 1),
                _withDirectives(_createElementVNode("select", {
                  name: "countryCode",
                  class: "form-select form-select-sm pe-0",
                  id: "color",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((countryCode).value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryCodes), (cCode, key) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: key,
                      value: cCode
                    }, _toDisplayString(cCode.dialCode + ' ' + cCode.code), 9, _hoisted_7))
                  }), 128))
                ], 512), [
                  [_vModelSelect, countryCode.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('services.labels.phone')), 1),
                _createVNode(AutoComplete, {
                  fieldName: 'phone',
                  idField: service.value.id,
                  onSelected: onClientSelected,
                  onOnChange: checkPhoneNoExists,
                  elements: clientsPhone.value,
                  "search-handler": searchClientsAutocomplete,
                  modelValue: service.value.phone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((service.value.phone) = $event)),
                  placeholder: _ctx.$t('services.placeholders.phone'),
                  normalizer: _unref(StrHelper).formatNumber,
                  debounceMs: 150,
                  disabled: !clientsAutocompleteReady.value,
                  classes: "form-control form-control-sm",
                  icon: "fas fa-phone"
                }, null, 8, ["idField", "elements", "modelValue", "placeholder", "normalizer", "disabled"]),
                _createVNode(_unref(Field), {
                  name: "client_id",
                  type: "hidden",
                  modelValue: service.value.client_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((service.value.client_id) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("input", _mergeProps({
                      type: "hidden",
                      name: "client_id"
                    }, field), null, 16)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('services.labels.name')), 1),
                _createVNode(_unref(Field), {
                  name: "name",
                  type: "text",
                  modelValue: service.value.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((service.value.name) = $event))
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _withDirectives(_createElementVNode("input", _mergeProps({
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      placeholder: _ctx.$t('services.placeholders.name')
                    }, field, { autocomplete: "off" }), null, 16, _hoisted_14), [
                      [_vModelDynamic, field.value]
                    ]),
                    (errorMessage || !meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_unref(ErrorMessage), { name: "name" }, {
                  default: _withCtx(({ message }) => [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(message), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('services.labels.start_address')), 1),
                _createVNode(AutoComplete, {
                  idField: service.value.id + 1,
                  fieldName: 'start_address',
                  onSelected: locSelected,
                  onOnChange: onStartAddressChange,
                  elements: placesAutocomplete.value,
                  "search-handler": searchPlacesAutocomplete,
                  placeholder: _ctx.$t('services.placeholders.start_address'),
                  disabled: !placesAutocompleteReady.value,
                  classes: "form-control form-control-sm",
                  icon: "fas fa-location-dot"
                }, null, 8, ["idField", "elements", "placeholder", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('services.labels.end_address')), 1),
                _createVNode(AutoComplete, {
                  idField: service.value.id + 2,
                  fieldName: 'end_address',
                  onSelected: endLocSelected,
                  onOnChange: onEndAddressChange,
                  elements: placesAutocomplete.value,
                  "search-handler": searchPlacesAutocomplete,
                  placeholder: _ctx.$t('services.placeholders.end_address'),
                  disabled: !placesAutocompleteReady.value,
                  classes: "form-control form-control-sm",
                  icon: "fas fa-location-dot"
                }, null, 8, ["idField", "elements", "placeholder", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('services.labels.comment')), 1),
                _createVNode(_unref(Field), {
                  name: "comment",
                  type: "text",
                  modelValue: service.value.comment,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((service.value.comment) = $event))
                }, {
                  default: _withCtx(({ field, errorMessage }) => [
                    _withDirectives(_createElementVNode("input", _mergeProps({
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      placeholder: _ctx.$t('services.placeholders.comment')
                    }, field, { autocomplete: "none" }), null, 16, _hoisted_26), [
                      [_vModelDynamic, field.value]
                    ]),
                    errorMessage
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_unref(ErrorMessage), { name: "comment" }, {
                  default: _withCtx(({ message }) => [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(message), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('services.labels.count')), 1),
                _withDirectives(_createElementVNode("select", {
                  name: "count",
                  class: "form-select form-select-sm pe-0",
                  id: "color",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((count).value = $event)),
                  disabled: isTestService.value
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (count) => {
                    return _createElementVNode("option", {
                      key: count,
                      value: count
                    }, _toDisplayString(count), 9, _hoisted_33)
                  }), 64))
                ], 8, _hoisted_32), [
                  [_vModelSelect, count.value]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('services.labels.line')), 1),
                _createVNode(_unref(Field), {
                  name: "wp_client_id",
                  class: "form-select form-select-sm pe-0",
                  modelValue: service.value.wp_client_id,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((service.value.wp_client_id) = $event)),
                  as: "select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wpClients), (client) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: client.id,
                        value: client.id,
                        selected: client.id == _unref(defaultClient)
                      }, _toDisplayString(client.alias), 9, _hoisted_38))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_unref(ErrorMessage), { name: "wp_client_id" }, {
                  default: _withCtx(({ message }) => [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(message), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "field-label" }, " ", -1)),
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    id: "isTestServiceToggle",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isTestService).value = $event))
                  }, null, 512), [
                    [_vModelCheckbox, isTestService.value]
                  ]),
                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('services.labels.test_toggle')), 1)
                ])
              ])
            ]),
            (isTestService.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('services.labels.target_driver')), 1),
                    _createVNode(AutoComplete, {
                      idField: 'fieldTargetDriver',
                      fieldName: 'target_driver',
                      onSelected: onTargetDriverSelected,
                      onOnChange: onTargetDriverChange,
                      elements: targetDriverPlates.value,
                      placeholder: _ctx.$t('drivers.placeholders.plate'),
                      classes: "form-control form-control-sm",
                      icon: "fas fa-car"
                    }, null, 8, ["elements", "placeholder"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("button", {
                class: "btn btn-primary d-inline-flex align-items-center submit-btn",
                type: "submit",
                disabled: submitting.value
              }, [
                (submitting.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49))
                  : (_openBlock(), _createElementBlock("em", _hoisted_50)),
                _createTextVNode(_toDisplayString(_ctx.$t('common.actions.create')) + " " + _toDisplayString(_ctx.$t('services.title', 1)), 1)
              ], 8, _hoisted_48)
            ])
          ]),
          (isTestService.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _cache[9] || (_cache[9] = _createElementVNode("em", { class: "fas fa-circle-info me-2" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('services.messages.test_notice')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}
}

})